import { render, staticRenderFns } from "./SmallScoreTable.vue?vue&type=template&id=20348715&scoped=true"
import script from "./SmallScoreTable.vue?vue&type=script&lang=js"
export * from "./SmallScoreTable.vue?vue&type=script&lang=js"
import style0 from "./SmallScoreTable.vue?vue&type=style&index=0&id=20348715&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20348715",
  null
  
)

export default component.exports